<template>
<v-container fluid>
  <v-form ref="form">
    <CheckBox class="ml-4" 
    :label="$t('Использовать онлайн оплаты')" 
    :hint="$t('Заказы оформленные онлайн будут отправляться в чат')" 
    :original_value="config.pay_enable" 
    v-model="local_config.pay_enable"/>

    <RefSelector 
        required
        :loading="any_loading"
        :items="references.employee_ref"
        :config="config"
        v-model="local_config" 
        field_name="casher"

        :label="$t('Идентификатор кассира')" 
        :hint="$t('Пользователь от имени которого будет вноситься оплата в заказ')" 
      />
    
    <RefSelector 
        required
        :loading="any_loading"
        :items="references.currency_ref"
        :config="config"
        v-model="local_config" 
        field_name="currency"

        :label="$t('Валюта для оплаты')" 
        :hint="$t('Данной валютой будет добавляться предоплата через онлайн оплату')" 
      />

    <v-row>
    <v-col cols="12" md="6">
        <SelectField 
        :loading="any_loading"
        :label="$t('Платежный агент')"
        :hint="$t('Выберите платежный агент, через которого будут проходить оплтаы')"
        :items="pay_agents"
        v-model="local_config.pay_agent"
        :original_value="config.pay_agent"
        />
    </v-col>

    <v-col
        cols="12"
        md="6"
        class="d-flex align-center"
    >
        <CheckBox 
        class="ma-0 mt-n3"
        :label="$t('Проводить тестовые платежи')" 
        :hint="$t('Платежи будут проходить через тестовую среду платежной системы')" 
        :original_value="config.test_pay" 
        v-model="local_config.test_pay"
        />
    </v-col>
    </v-row>

    <div class="warning-text mt-2">
        <T>Оплата заказа клиентом через платёжный агрегатор зачисляется как предоплата.</T>
    </div>
    <p></p>

    <h3><T>Настройки платежного агента:</T></h3>
    <p></p>

    <TextField 
      :loading="any_loading"
      :label="`${$t('Время ожидания оплаты (минуты)')}`"
      :hint="$t('Время в течении которого будет агент проверяет состояние оплаты')"
      :original_value="config.time_pay"
      v-model="local_config.time_pay"
      required
    />

    <TextField 
      :loading="any_loading"
      :label="`${$t('Описание заказа')}`"
      :hint="$t('Эти слова увидит клиент при оплате в информационном поле платежного агента')"
      :original_value="config.pay_description"
      v-model="local_config.pay_description"
    />
    
    <SelectField 
      :loading="any_loading"
      :label="$t('Система налогообложения')"
      :hint="$t('Эти слова увидит клиент при оплате в информационном поле платежного агента')"
      :items="NDS_System"
      item-text="name"
      item-value="code"
      v-model="local_config.taxation_system"
      :original_value="config.taxation_system"
    />

    <SelectField 
        :loading="any_loading"
        :label="$t('НДС')"
        :hint="$t('Эти слова увидит клиент при оплате в информационном поле платежного агента')"
        :items="NDS_rates"
        item-text="name"
        item-value="code"
        v-model="local_config.nds"
        :original_value="config.nds"
    />

    <TextField 
      :loading="any_loading"
      :label="`${$t('Номер сектора')}`"
      :hint="$t('Номер сектора платежного агента')"
      :original_value="config.sector"
      v-model="local_config.sector"
    />

    <TextField 
      :loading="any_loading"
      :label="`${$t('Платежный пароль')}`"
      :hint="$t('Пароль для формирования цифровой подпись')"
      :original_value="config.password"
      v-model="local_config.password"
    />

    <TextField 
      :loading="any_loading"
      :label="`${$t('Код валюты')}`"
      :hint="$t('Код валюты платежного агента')"
      :original_value="config.currency_code"
      v-model="local_config.currency_code"
    />

    <TextField 
      :loading="any_loading"
      :label="`${$t('КПП')}`"
      :hint="$t('КПП')"
      :original_value="config.kpp"
      v-model="local_config.kpp"
    />

  </v-form>
</v-container>
</template>

<script>
import TextField from '../../common/TextField.vue'
import CheckBox from '../../common/CheckBox.vue'
import RefSelector from '../references/RefSelector.vue'
import settings_group_mixin from '../settings_group_mixin'
import SelectField from '../../common/SelectField.vue'

export default {
  mixins: [settings_group_mixin],
  data: () => ({
    local_loading: false,
    locales: [],
    references: {},
    pay_agents: ['Best2Pay'],
    NDS_System : [
        { 'code': 0, 'name': 'Общая, ОСН' },
        { 'code': 1, 'name': 'Упрощенная доход, УСН доход' },
        { 'code': 2, 'name': 'Упрощенная доход минус расход, УСН доход - расход' },
        { 'code': 3, 'name': 'Единый налог на вмененный доход, ЕНВД' },
        { 'code': 4, 'name': 'Единый сельскохозяйственный налог, ЕСН' },
        { 'code': 5, 'name': 'Патентная система налогообложения, Патент' },
    ],
    NDS_rates: [
        { 'code': 1, 'name': 'Cтавка НДС 20%' },
        { 'code': 2, 'name': 'Cтавка НДС 10%' },
        { 'code': 3, 'name': 'Cтавка НДС расч. 20/120' },
        { 'code': 4, 'name': 'Cтавка НДС расч. 10/110' },
        { 'code': 5, 'name': 'Cтавка НДС 0%' },
        { 'code': 6, 'name': 'НДС не облагается' },
        { 'code': 7, 'name': 'Cтавка НДС 5%' },
        { 'code': 8, 'name': 'Cтавка НДС 7%' },
        { 'code': 9, 'name': 'Cтавка НДС расч. 5/105' },
        { 'code': 10, 'name': 'Cтавка НДС расч. 7/107' }
    ],
  }),

  computed: {
    any_loading() {
      return this.local_loading || this.local_loading
    }
  },
  
  methods: {
    validate(){
      if (!this.$refs.form.validate()) {
        throw new Error(this.$t('Некоторые поля заполнены с ошибкой'))
      }
    },

    async loadReferences(){
      this.local_loading = true
      try {
        this.references = await this.$store.dispatch('apiQuery', {method: '/references'})
        this.locales = await this.$store.dispatch('getAvailableLocales')
      } catch (e) {
        console.log(e)
      } finally {
        this.local_loading = false
      }
    }
  },
  async mounted(){
    await this.loadReferences()
    // console.log('this.references')
    // console.log(this.references)
    // console.log('config')
    // console.log(this.config)
  },
  components: {
    TextField,
    CheckBox,
    RefSelector,
    SelectField
  }
}
</script>